module.exports = __webpack_public_path__ + "img/TabelleSuche.b7e84d95.png";